export const timesheetsQueryKeys = {
  timesheets_by_range: (queryParams = {}) => [
    'timesheets_by_range',
    queryParams
  ]
}
